/**
 * Resolve Paymob iframe URL from API response, with client-side fallback when the
 * backend returns payment_token but PAYMOB_IFRAME_ID is not configured server-side.
 */
export function resolvePaymobCheckoutUrl(data) {
  if (!data) return null;
  if (data.checkout_url) return data.checkout_url;

  const token = data.payment_token;
  if (!token) return null;

  const iframeId = process.env.REACT_APP_PAYMOB_IFRAME_ID?.trim();
  if (!iframeId) return null;

  return `https://accept.paymob.com/api/acceptance/iframes/${iframeId}?payment_token=${token}`;
}
